export enum Gender {
    MALE = 'male',
    FEMALE = 'female',
}

export const GENDER_NAMES: { [key in Gender]: string } = {
    [Gender.MALE]: $localize`:@@gender.male:Herr`,
    [Gender.FEMALE]: $localize`:@@gender.female:Frau`,
};
